class ButtonApllyFilter extends HTMLElement {
    constructor() {
        super()

        this.querySelector('button').addEventListener("click", this.closeFilters.bind(this))
    }

    closeFilters() {
        const overlayBg = document.querySelector('.mobile-filters-overlay.active .overlay-bg')
        overlayBg.click()
    }
}

customElements.define("button-filter", ButtonApllyFilter)